import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=6071dd74"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Skeleton: require('/vercel/path0/components/ui/skeleton.vue').default,Rating: require('/vercel/path0/components/ui/rating.vue').default,Swiper: require('/vercel/path0/components/ui/swiper.vue').default,Link: require('/vercel/path0/components/ui/link.vue').default,Counter: require('/vercel/path0/components/ui/counter.vue').default,Favorite: require('/vercel/path0/components/ui/favorite.vue').default,Img: require('/vercel/path0/components/ui/img.vue').default,Dropdown: require('/vercel/path0/components/ui/dropdown.vue').default,Block: require('/vercel/path0/components/ui/block.vue').default,StockNotification: require('/vercel/path0/components/ui/stockNotification.vue').default})
